import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["feedback", "source", "message"]
  static values = {
    text: String,
    successMessage: { type: String, default: "复制成功" }
  }

  connect() {
    this.hideFeedback()
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  copy(event) {
    event.preventDefault()

    const text = this.textValue || (this.hasSourceTarget ? this.sourceTarget.textContent.trim() : "")

    if (!text) return

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
        .then(() => this.showFeedback())
        .catch(() => this.fallbackCopy(text))
    } else {
      this.fallbackCopy(text)
    }
  }

  fallbackCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.setAttribute("readonly", "")
    textarea.style.position = "absolute"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)

    const selection = document.getSelection()
    const previousRange = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null

    textarea.select()

    try {
      document.execCommand("copy")
      this.showFeedback()
    } catch (error) {
      console.error("copy-to-clipboard: failed to copy text", error)
    }

    document.body.removeChild(textarea)

    if (previousRange && selection) {
      selection.removeAllRanges()
      selection.addRange(previousRange)
    }
  }

  showFeedback() {
    if (!this.hasFeedbackTarget) return

    if (this.hasMessageTarget) {
      this.messageTarget.textContent = this.successMessageValue
    } else {
      this.feedbackTarget.textContent = this.successMessageValue
    }

    this.feedbackTarget.classList.remove("hidden")

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.hideFeedback(), 1600)
  }

  hideFeedback() {
    if (!this.hasFeedbackTarget) return

    this.feedbackTarget.classList.add("hidden")
  }

}
